import clsx from 'clsx'
import {KTSVG} from '../../../helpers'
import {HeaderUserMenu, HeaderUserMenuProps} from '../../../partials'
import {useLayout} from '../../core'
import {AvatarInitials} from '../../../../app/components/utils/AvatarInitials'

const toolbarButtonMarginClass = 'ms-1 ms-lg-3'
const toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px'

export interface TopbarProps extends HeaderUserMenuProps {
  initials: string
  hideToggler?: boolean
}

const Topbar = ({initials, hideToggler, ...headerProps}: TopbarProps) => {
  const {config} = useLayout()

  return (
    <div className='d-flex align-items-stretch flex-shrink-0'>
      {/* begin::User */}
      <div
        className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
        id='kt_header_user_menu_toggle'
      >
        {/* begin::Toggle */}
        <div
          className={clsx('cursor-pointer symbol bg-opacity-10', toolbarUserAvatarHeightClass)}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          data-kt-menu-flip='bottom'
        >
          <AvatarInitials className='fs-2'>{initials}</AvatarInitials>
        </div>
        <HeaderUserMenu {...headerProps} />
        {/* end::Toggle */}
      </div>
      {/* end::User */}

      {/* begin::Aside Toggler */}
      {!hideToggler && config.header.left === 'menu' && (
        <div className='d-flex align-items-center d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px'
            id='kt_header_menu_mobile_toggle'
          >
            <KTSVG path='/media/icons/duotone/Text/Toggle-Right.svg' className='svg-icon-1' />
          </div>
        </div>
      )}
    </div>
  )
}

export {Topbar}
